module.exports = __webpack_public_path__ + "82b6cabe717c051ab4c1ca76f8084807.png";